import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

function ProductOrderInfo ({ children, title, textRow1, textRow2, warningRow, image, className }) {
  const titleElement = title || children ? <div className='text-sm font-medium leading-5 truncate'>{title || children}</div> : null
  const textRow1Element = textRow1 ? <div className='text-sm text-gray-500 leading-5 truncate'>{textRow1}</div> : null
  const textRow2Element = textRow2 ? <div className='text-sm text-gray-500 leading-5 truncate'>{textRow2}</div> : null
  const warningRowElement = warningRow ? <div className='text-sm text-red-400 leading-5 truncate'>{warningRow}</div> : null
  const imageElement = image ? <div className='w-12 h-12 flex items-center justify-center mr-4 flex-shrink-0 overflow-hidden'>{image}</div> : null

  const _className = classNames(
    'flex items-center w-full',
    className
  )

  return (
    <div className={_className}>
      {imageElement}
      <div className='group space-y-1 w-1/4 flex-grow max-w-2xs xl:max-w-full'>
        {titleElement}
        {textRow1Element}
        {textRow2Element}
        {warningRowElement}
      </div>
    </div>
  )
}

ProductOrderInfo.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  textRow1: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  textRow2: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  warningRow: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ])
}

export default ProductOrderInfo
